import { useState } from "react";
import { Apis } from "../../../lib/Apis";
import axios from "axios";
import Swal from "sweetalert2";

export const useProducts = () => {
    const [loading, setLoading] = useState(false);
    const getProducts = async (setProducts) => {
        try {
            const response = await Apis.getProducts();
            const payload = response?.data?.data;
            if (payload && Array.isArray(payload.products)) {
                setProducts(payload.products);
            } else {
                console.error("Invalid response format:", response);
            }
        } catch (error) {
            console.error("Error in Hook:", error.message || error);
        }
    };

    const getProductsWithPagination = async (setProducts, setTotal, offset = 0, limit = 20, searchQuery = "", statusFilter = "", categoryName = "") => {
        setLoading(true);
        try {
            const params = {};

            if (statusFilter !== "") {
                params.status = statusFilter === "true" ? true : false;
            }

            if (searchQuery && searchQuery.trim()) {
                params.name = searchQuery.trim();
            }

            if (categoryName && categoryName.trim()) {
                params.categoryName = categoryName.trim();
            }

            const response = await Apis.getProductsWithPagination(offset, limit, params);
            if (response?.status === 200) {
                const payload = response?.data?.data || {};
                const products = payload.products || [];
                setProducts(products);
                const totalRecords = payload.pagination?.totalRecords || products.length;
                setTotal(totalRecords);
                return payload;
            } else {
                throw new Error(response?.data?.message || "Failed to fetch products.");
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            throw new Error(error?.response?.data?.message || error.message || "Error fetching products.");
        } finally {
            setLoading(false);
        }
    };

    const getCategories = async (setCategories) => {
        try {
            const response = await Apis.getCategoriesToAddProducts();
            const payload = response?.data?.data;
            if (
                payload &&
                Array.isArray(payload.categories)
            ) {
                setCategories(payload.categories);
            } else {
                console.error("Invalid response format:", response);
                setCategories([]);
            }
        } catch (error) {
            console.error("Error fetching categories:", error?.message || error);
            setCategories([]);
        }
    };
    const updateProductStatus = async (id, status) => {
        try {
            setLoading(true);
            const requestBody = {
                id,
                status,
            };
            const response = await Apis.updateProductStatus(requestBody);
            if (response && response.data?.success) {
                return response.data;
            } else {
                console.error("Invalid response format:", response);
                return null;
            }
        } catch (error) {
            console.error("Error in Hook:", error?.response?.data?.message || error.message || error);
            throw new Error(error?.response?.data?.message || "Failed to update product status.");
        } finally {
            setLoading(false);
        }
    };
    const deleteProduct = async (id) => {
        try {
            const response = await Apis.deletProduct(id);
            if (response && response.data?.success) {
                return response.data;
            } else {
                console.error("Invalid response format:", response);
                return null;
            }
        } catch (error) {
            console.error("Error in Hook:", error?.response?.data?.message || error.message || error);
            throw new Error(error?.response?.data?.message || "Failed to delete product.");
        }
    };
    const addProduct = async (formData) => {
        try {
            const response = await Apis.addProduct(formData);
            return response.data;
        } catch (error) {
            console.error(error);
            throw new Error(error?.response?.data?.message || error.message || "Failed to add product.");
        }
    };
    const updateProduct = async (updateId, data) => {
        try {
            const response = await Apis.updateProduct(updateId, data);
            return response?.data;
        } catch (error) {
            console.error(error);
            throw new Error(error?.response?.data?.message || error.message || "Failed to update product.");
        }
    };
    const getBrands = async (setBrandsData) => {
        try {
            const response = await Apis.getBrands();
            const brands = response?.data?.data?.brands || [];
            setBrandsData(brands);
            return brands;
        } catch (error) {
            throw new Error(error?.response?.data?.message || error.message || "Failed to fetch brands.");
        }
    };

    const updateProductPosition = async (productId, newPosition) => {
        try {
            const response = await Apis.updateProductPosition(productId, newPosition);
            return response?.data ?? response;
        } catch (error) {
            console.error("Error in Hook:", error?.response?.data?.message || error.message || error);
            throw new Error(error?.response?.data?.message || "Failed to update product position.");
        }
    };

    return {
        getProducts,
        getProductsWithPagination,
        getCategories,
        updateProductStatus,
        deleteProduct,
        addProduct,
        updateProduct,
        getBrands,
        updateProductPosition
    };
};

export default useProducts;